export default {
  'common.prompt_dialog.dialog.title': 'Continue without saving?',
  'common.prompt_dialog.dialog.text': 'Your changes will be ignored.'
}
